import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@diggens/api-client';

interface SubmissionDetail {
  id: string;
  status: string;
  period: string;
  source_type: string;
  submitted_at: string | null;
  email_body: string | null;
  metrics: any[];
  files: any[];
  portfolio_companies: any;
  submission_thread: any[];
  [key: string]: unknown;
}

export function useSubmissionDetails(submissionId: string | null) {
  return useQuery({
    queryKey: ['submission-details', submissionId],
    queryFn: () => apiFetch<SubmissionDetail>(`/resource/submissions/${submissionId}?select=*,metrics(*,metric_definitions(*)),submission_thread(*),portfolio_companies(*)`),
    enabled: !!submissionId,
  });
}
